export default __webpack_public_path__ + "7319baad5eed8e648ab40f9acd7788a1.png";